import React, { useState, useEffect, useRef } from 'react';
import { Input } from 'antd';

function loadScript(url, callback) {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = url;
  script.onload = callback;
  document.head.appendChild(script);
}

let autoComplete;

async function handlePlaceSelect(updateQuery, setMapsAddress) {
  const addressObject = autoComplete.getPlace();
  const lat = addressObject.geometry?.location?.lat();
  const lng = addressObject.geometry?.location?.lng();
  updateQuery(addressObject.name || '');
  setMapsAddress({
    address: addressObject.formatted_address,
    name: addressObject.name,
    lat,
    lng,
    object: addressObject,
  });
}

// types: optional array to restrict autocomplete (e.g. ['(cities)'])
const SearchLocationInput = ({
  setMapsAddress,
  initialValue = '',
  onChange,
  types = [],
  placeholder = 'Donde queda la pista?',
}) => {
  const [query, setQuery] = useState(initialValue);
  const inputRef = useRef(null);

  useEffect(() => {
    if (initialValue) setQuery(initialValue);
  }, [initialValue]);

  useEffect(() => {
    const init = () => {
      const domInput = inputRef.current?.input;
      if (!domInput) return;
      const options = {};
      if (types.length > 0) options.types = types;
      autoComplete = new window.google.maps.places.Autocomplete(domInput, options);
      autoComplete.setFields(['name', 'address_components', 'formatted_address', 'geometry']);
      autoComplete.addListener('place_changed', () =>
        handlePlaceSelect(setQuery, setMapsAddress),
      );
    };

    if (window.google?.maps?.places) {
      init();
    } else {
      loadScript(
        `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_MAPS_API_KEY}&libraries=places&callback=Function.prototype`,
        init,
      );
    }
  }, []);

  return (
    <Input
      ref={inputRef}
      value={query}
      placeholder={placeholder}
      onChange={e => {
        const val = e.target.value;
        setQuery(val);
        setMapsAddress({ address: val, name: val });
        onChange?.(val);
      }}
    />
  );
};

export default SearchLocationInput;
